import type { HTMLComponent } from "@commercekit/react";
import type { RichTextSliceDefault } from "prismicio-types";
import { asText } from "@prismicio/helpers";
import { useMemo } from "react";
import { wrapIframe } from "@commercekit/shared";

const WvRichTextWithHeading: HTMLComponent<{
  slice: RichTextSliceDefault;
}> = ({ slice }) => {
  const content = useMemo(() => {
    return wrapIframe(asText(slice?.primary?.rich_content));
  }, [slice?.primary?.rich_content]);
  return (
    <div className="col-12 px-0">
      <div className="container">
        <div className="row">
          <div className="col-12">
            {slice.primary.heading && slice.primary.heading.length > 0 && (
              <h1 className="heading strong xl underlined left pb-3 mb-3">
              {" "}
              {asText(slice?.primary?.heading)}
            </h1>
            )}
          </div>
          <div className="col-12 ">
            <div
              className="content"
              dangerouslySetInnerHTML={{
                __html: content || "",
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WvRichTextWithHeading;
